import React from "react";
import Wrapper from "../layout/Wrapper";
import ContactUsBanner from "../components/ContactUsComp/ContactUsBanner";
import FollowUsOn from "../components/ContactUsComp/FollowUsOn";
import DesignFutureSec from "../components/HomeSecComp/DesignFutureSec";

export default function ContactUs() {
  return (
    <Wrapper>
      <ContactUsBanner />
      <FollowUsOn />
      <DesignFutureSec />
    </Wrapper>
  );
}
